import React, { FC } from 'react';
import { join, map } from 'lodash';
import { Block } from '@bechtel/types';
import { Text, Box, Icon } from '@bechtel/gds';
import { BlockStyled } from '../../resolve/styled';
import { BlockHeadingStyled } from '../styled';
import { Trans } from '@lingui/macro';
import { BlockTypeMessages, BlockTypeDescriptionMessages } from '~/components/atoms';
import { MultiBlockSideSheetContentColStyled } from '../../styled';
import { CommodityList } from '../types';

export interface BlocksSubmittedProps {
  selectedCommodities: CommodityList[];
  submittedBlocks: Block[];
}

export const BlocksSubmitted: FC<BlocksSubmittedProps> = ({ selectedCommodities, submittedBlocks }) => {
  const selectedCommoditiesJoined = join(map(selectedCommodities, 'tag'), ', ');

  return (
    <MultiBlockSideSheetContentColStyled>
      <BlockHeadingStyled>
        <Trans>Selected Commodities:</Trans>
      </BlockHeadingStyled>
      <Box p={{ sm: '500' }}>
        <Text size="400" color="grey.1000">
          {selectedCommoditiesJoined}
        </Text>
      </Box>

      <BlockHeadingStyled>
        <Trans>Submitted Blocks</Trans>
      </BlockHeadingStyled>
      {submittedBlocks.length === 0 && (
        <Box p={{ sm: '500' }}>
          <Text>
            <Trans>You do not have any blocks submitted yet.</Trans>
          </Text>
        </Box>
      )}

      {map(submittedBlocks, (blockItem: Block, index) => {
        return (
          <BlockStyled key={blockItem.id} selected={false}>
            <Box flexDirection={{ sm: 'column' }}>
              <Box mb={{ sm: '400' }}>
                <Text size="400" weight="600" color="bechtel.grey.1000">
                  <Trans>Block</Trans> {index + 1}: <Trans id={BlockTypeMessages[blockItem.type.title].id}></Trans>
                </Text>
              </Box>
              <Text size="400" color="bechtel.grey.1000">
                <Trans id={BlockTypeDescriptionMessages[blockItem.type.description].id}></Trans>
              </Text>
            </Box>
            <Box alignSelf={{ sm: 'flex-start' }}>
              <Icon icon="edit" />
            </Box>
          </BlockStyled>
        );
      })}
      {/* NOTE: I am keeping this commented out for now as it is a tad confusing for users */}
      {/* NOTE: The intended UX is after a block submission we just reset the form in the right col so they can add a new block right away */}
      {/* {submittedBlocks.length > 0 && (
        <Box p={{ sm: '500' }}>
          <Button appearance={ButtonAppearance.PRIMARY}>Add an additional block</Button>
        </Box>
      )} */}
    </MultiBlockSideSheetContentColStyled>
  );
};
